import { gql } from '@apollo/client';

import { Exercise } from '../../types';
import { exerciseFragment } from '../fragments';

export interface GetExercisesQueryVariables {
  courseId: string;
  subjectId: string;
}

export interface GetExercisesQueryResult {
  exercises: Exercise[];
}

export const getExercisesQuery = gql`
  query GetExercisesQuery($courseId: String!, $subjectId: String!) {
    exercises(courseId: $courseId, subjectId: $subjectId)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises") {
      ...Exercise
    }
  }
  ${exerciseFragment}
`;
